<span class="badge bg-{{properties.type}} no-border-radius"> {{properties.content}}</span> <span> </span>